<div style="margin-top: 15px;" *ngIf="assetTriggers && assetTriggers.length > 0">
  <div class="card p-datatable p-component p-datatable-striped p-datatable-hoverable-rows">
    <p-table
      [(first)]="first"
      [(rows)]="rows"
      [value]="assetTriggers"
      [totalRecords]="totalTriggers"
      [responsive]="true"
      [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
      [paginator]="true"
      [rowsPerPageOptions]="[10,25,50]"
      [lazy]="true"
      (onLazyLoad)="onPageChange($event)"
      styleClass="p-datatable-striped"
      sortField="name"
    >
      <ng-template pTemplate="header">
        <tr>
          <th scope="col" pSortableColumn="name">
            {{'attribute.name' | transloco}}<p-sortIcon field="name"></p-sortIcon></th>
          <th scope="col" pSortableColumn="ownerUuid">
            {{'attribute.ruleType' | transloco}}<p-sortIcon field="ownerUuid"></p-sortIcon></th>
          <th scope="col" pSortableColumn="category">
            {{'attribute.category' | transloco}}<p-sortIcon field="category"></p-sortIcon></th>
          <th pSortableColumn="active">
            {{'attribute.active' | transloco}}<p-sortIcon field="active"></p-sortIcon></th>
          <th scope="col" >
            {{'attribute.measurementName' | transloco}}</th>
          <th scope="col" >
            {{'attribute.valueEvaluated' | transloco}}</th>
          <th scope="col" >
            {{'attribute.condition' | transloco}}</th>
          <th scope="col"  pSortableColumn="lastEvaluation">
            {{'attribute.result' | transloco}}<p-sortIcon field="lastEvaluation"></p-sortIcon></th>
          <th scope="col" pSortableColumn="evaluationDate">
            {{'attribute.evaluationDate' | transloco}}<p-sortIcon field="evaluationDate"></p-sortIcon></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-trigger>
        <tr *ngIf="!loadingTriggers">
          <td>
            <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
            {{trigger.name}}
          </td>
          <td>
            <span class="p-column-title bold">{{'attribute.ownerUuid' | transloco}}</span>
            <p *ngIf="trigger.ownerUuid">{{ "common.user" | transloco }}</p>
            <p *ngIf="!trigger.ownerUuid">{{ "menu.system" | transloco }}</p>
          </td>
          <td>
            <span class="p-column-title bold">{{'attribute.category' | transloco}}</span>
            <p>{{ 'model.triggerCategories.' + trigger.category.toLowerCase() | transloco }}</p>
          </td>
          <td>
            <span class="p-column-title bold">{{'attribute.active' | transloco}}</span>
            <p *ngIf="trigger.active">{{'common.active' | transloco}}</p>
            <p *ngIf="!trigger.active">{{'common.inactive' | transloco}}</p>
          </td>
          <td>
            <span class="p-column-title bold">{{'attribute.measurementName' | transloco}}</span>
            {{trigger.assetMeasurement ? trigger.assetMeasurement.name : ''}}
          </td>
          <td>
            <span class="p-column-title bold">{{'attribute.valueEvaluated' | transloco}}</span>
            {{trigger.lastValueEvaluated}}
          </td>
          <td>
            <span class="p-column-title bold">{{'attribute.condition' | transloco}}</span>
            <p-tag value="{{trigger.type}}({{trigger.expression}})" severity="info"></p-tag>
          </td>
          <td class="m-0" *ngIf="trigger.lastEvaluation != null && trigger.lastEvaluation != undefined">
            <span class="p-column-title bold">{{'attribute.result' | transloco}}</span>
            <p [className]="trigger.lastEvaluation ? 'success-color' : 'danger-color'">
              <i [className]="trigger.lastEvaluation ? 'pi pi-check' : 'pi pi-times'"></i>
              {{(trigger.lastEvaluation ? 'common.true' : 'common.false') | transloco}}
            </p>
          </td>
          <td class="m-0" *ngIf="trigger.lastEvaluation == null || trigger.lastEvaluation == undefined"></td>
          <td>{{trigger.evaluationDate | customDate}}</td>
        </tr>
        <tr *ngIf="loadingTriggers">
          <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div class="flex">
          <div class="my-auto">
            <div *ngIf="totalTriggers == 0">
              {{'pagination.empty' | transloco}}
            </div>
            <div *ngIf="totalTriggers > 0">
              {{'pagination.showing' | transloco}} {{first+1}}
              {{'pagination.to' | transloco}} {{(first+rows) >= totalTriggers ? totalTriggers : (first+rows)}}
              {{'pagination.of' | transloco}} {{totalTriggers}}
              {{(totalTriggers > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
            </div>
          </div>
        </div>
      </ng-template>
    </p-table>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="assetTriggers && assetTriggers.length == 0">
  <div class="card w-full">
    <p class="text-xl text-center p-6 font-italic">{{'empty.triggers' | transloco}}</p>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="!assetTriggers && loadingTriggers">
  <div class="card w-full">
    <app-table-skeleton [rows]="14"></app-table-skeleton>
  </div>
</div>
